import { Button, Result } from 'antd';

const NotFound = () => (
  <Result
    status="404"
    title="404"
    subTitle="Lo sentimos, la pagina a la que intentas acceder no existe"
    extra={
      <Button href="/" type="primary">
        volver al inicio
      </Button>
    }
  />
);

export default NotFound;
